import { useNavigate } from 'react-router-dom';
import { Banner } from '../components/Banner';
import { useT } from '../i18n';

export function Profile() {
  const { t } = useT();
  const navigate = useNavigate();
  return (
    <>
      <Banner />
      <main style={{ padding: '20px', maxWidth: 540, margin: '0 auto' }}>
        <button
          style={{ background: 'transparent', border: 0, color: 'var(--ink-soft)', padding: '8px 0' }}
          onClick={() => navigate(-1)}
        >
          ← {t('settings.back')}
        </button>
        <h1 style={{ fontSize: 28, marginTop: 8 }}>{t('profile.title')}</h1>
        <p style={{ color: 'var(--ink-soft)' }}>{t('profile.placeholder')}</p>
      </main>
    </>
  );
}
